import type { FichaTemplate } from './types'

export interface FieldDef {
  key: string
  label: string
  type: 'number' | 'text' | 'yesno'
  unit?: string
  min?: number
  max?: number
  placeholder?: string
}

export const TEMPLATE_OPTIONS: Array<{ value: FichaTemplate; label: string; description: string }> =
  [
    {
      value: 'laboratorio',
      label: 'Laboratorio',
      description: 'Hemoglobina, glucosa, colesterol, triglicéridos',
    },
    {
      value: 'antropometria',
      label: 'Antropometría',
      description: 'Peso, altura, BMI, presión arterial',
    },
    {
      value: 'encuesta',
      label: 'Encuesta',
      description: 'Cuestionario 10 preguntas Sí/No',
    },
  ]

export const LABORATORIO_FIELDS: FieldDef[] = [
  { key: 'hemoglobina', label: 'Hemoglobina', type: 'number', unit: 'g/dL', min: 0, max: 25 },
  { key: 'glucosa', label: 'Glucosa', type: 'number', unit: 'mg/dL', min: 0, max: 500 },
  { key: 'colesterol', label: 'Colesterol total', type: 'number', unit: 'mg/dL', min: 0, max: 500 },
  {
    key: 'trigliceridos',
    label: 'Triglicéridos',
    type: 'number',
    unit: 'mg/dL',
    min: 0,
    max: 1000,
  },
]

export const ANTROPOMETRIA_FIELDS: FieldDef[] = [
  { key: 'peso_kg', label: 'Peso', type: 'number', unit: 'kg', min: 0, max: 300 },
  { key: 'altura_cm', label: 'Altura', type: 'number', unit: 'cm', min: 0, max: 250 },
  { key: 'bmi', label: 'IMC', type: 'number', unit: 'kg/m²', min: 0, max: 80 },
  {
    key: 'presion_sistolica',
    label: 'Presión sistólica',
    type: 'number',
    unit: 'mmHg',
    min: 0,
    max: 300,
  },
  {
    key: 'presion_diastolica',
    label: 'Presión diastólica',
    type: 'number',
    unit: 'mmHg',
    min: 0,
    max: 200,
  },
]

export const ENCUESTA_FIELDS: FieldDef[] = Array.from({ length: 10 }, (_, i) => ({
  key: `pregunta_${i + 1}`,
  label: `Pregunta ${i + 1}`,
  type: 'yesno' as const,
}))

export function fieldsForTemplate(template: FichaTemplate): FieldDef[] {
  switch (template) {
    case 'laboratorio':
      return LABORATORIO_FIELDS
    case 'antropometria':
      return ANTROPOMETRIA_FIELDS
    case 'encuesta':
      return ENCUESTA_FIELDS
  }
}

/** Calcula IMC automático dado peso y altura cm. */
export function computeBmi(pesoKg?: number, alturaCm?: number): number | undefined {
  if (!pesoKg || !alturaCm || alturaCm === 0) return undefined
  const meters = alturaCm / 100
  const bmi = pesoKg / (meters * meters)
  return Math.round(bmi * 10) / 10
}
